export const QUERY_KEYS = {
  user: {
    getCurrentProfile: ['getCurrentProfile'],
  },
  regulatoryIntake: {
    getIntakeDetails: (id: string) => ['getIntakeDetails', id],
    messagesSearch: (payload: object) => ['messagesSearch', payload],
    notificationSearch: (payload: object) => ['notificationSearch', payload],
    jobSearch: (payload: object) => ['jobSearch', payload],
    getAttentionDocuments: (emailId: string) => ['getAttentionDocuments', emailId],
  },
  source: {
    sourceDetails: () => ['sourceDetails'],
  },
  userManagement: {
    userSearch: (payload: object) => ['userSearch', payload],
    auditLogSearch: (payload: object) => ['auditLogSearch', payload],
    getUserDetails: (id: string) => ['getUserDetails', id],
  },
};
